<template>
  <div
    v-if="!isSelect(header) && !isActionsHeader(header)"
    class="noWrap"
    @mouseover="setHover(true)"
    @mouseleave="setHover(false)"
    @click="toggleOrder()"
  >
    <span>{{ header.text }} </span>
    <v-icon
      v-if="isSortable"
      class="orderArrow"
      :class="arrowClasses"
      small
    >
      mdi-menu-down
    </v-icon>
  </div>
  <div
    v-else-if="isSelect(header) && showSelect"
    class="d-flex align-center justify-start"
  >
    <v-checkbox
      v-model="selectAllRows"
      @change="handleSelectAll($event)"
    />
    <v-menu
      v-if="displaySelectList"
      offset-y
    >
      <template v-slot:activator="{ attrs, on }">
        <v-icon
          id="arrow"
          v-bind="attrs"
          class="elevation-0"
          v-on="on"
        >
          mdi-menu-down
        </v-icon>
      </template>
      <select-filter-list
        :items="selectListItems"
        @filter="filterSelectList($event)"
      />
    </v-menu>
  </div>
  <span
    v-else-if="isActionsHeader(header) && showActions"
    class="text-center"
  >Ações</span>
</template>

<script>
import SelectFilterList from '../crud/components/SelectFilterList.vue';

export default {
  name: 'DataTableHeaderCell',
  components: { SelectFilterList },
  props: {
    header: {
      type: Object,
      required: true,
    },
    selectAllRows: {
      type: Boolean,
      default: false,
    },
    displaySelectList: {
      type: [Boolean, Number],
      default: false,
    },
    selectListItems: {
      type: Array,
      default() {
        return [];
      },
    },
    showActions: {
      type: [Boolean, Number],
      default: true,
    },
    showSelect: {
      type: [Boolean, Number],
      default: false,
    },
  },
  data: () => ({
    hover: false,
    sortDir: null,
  }),
  computed: {
    arrowClasses() {
      return {
        inHover: this.hover && !this.sortDir,
        arrowUp: this.sortDir === 'ASC',
        arrowDown: this.sortDir === 'DESC',
      };
    },
    isSortable() {
      return this.header.sortDir === undefined || this.header.sortDir;
    },
    isSelect() {
      return (header) => header && (header.select || header.value === 'data-table-select');
    },
    isActionsHeader() {
      return (header) => header && (
        header.actions || header.value === 'data_table_actions'
      );
    },
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(value) {
        const { sortBy, sortDir } = value;
        this.sortDir = null;
        if (sortBy === this.header.value) {
          this.sortDir = sortDir;
        }
      },
    },
  },
  methods: {
    setHover(status) {
      this.hover = status;
    },
    toggleOrder() {
      if (!this.isSortable) {
        return;
      }

      let nextOrder = null;
      if (this.sortDir === null) {
        nextOrder = 'ASC';
      }

      if (this.sortDir === 'ASC') {
        nextOrder = 'DESC';
      }

      if (this.sortDir === 'DESC') {
        nextOrder = null;
      }

      this.sortDir = nextOrder;
      this.$emit('update-order', { column: this.header.value, sortDir: this.sortDir });
    },
    handleSelectAll(value) {
      this.$emit('handle-select-all', value);
    },
    filterSelectList(value) {
      this.$emit('filter-select-list', value);
    },
  },
};
</script>

<style>
.orderArrow{
  position: absolute;
  opacity: 0
}

.inHover{
  opacity: 0.6
}

.arrowUp{
  opacity: 1
}

.arrowDown{
  opacity: 1;
  transform: rotate(180deg)
}

</style>

<style scoped lang="sass">
.evenly
  display: flex
  align-items: center
  justify-content: center

#arrow
  margin-right: 0!important
</style>
